import { SVGProps, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

import { useTheme } from '@/features/theme-switch';

export default function Delete({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  const { darkTheme } = useTheme();

  const colors = useMemo(
    () =>
      darkTheme
        ? `stroke-[#FFFFFFE0] fill-transparent hover:fill-[#FFFFFF3D]`
        : `stroke-gray fill-transparent hover:stroke-[#2759FF66] hover:fill-[#2759FF14]`,
    [darkTheme]
  );

  return (
    <svg
      width={20}
      height={20}
      {...props}
      className={twMerge(
        `transition-all duration-300 ease-out hover:cursor-pointer ${colors}`,
        className
      )}
    >
      <path
        stroke="current"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M5 5c0 4.882-1.14 11.667 5 11.667 6.141 0 5-6.785 5-11.667M3.335 5h13.333m-4.166 0v-.833c0-1.48-1.365-1.667-2.5-1.667-1.136 0-2.5.187-2.5 1.667V5"
      />
    </svg>
  );
}
